import React from "react";
export default () => (React.createElement("div", { "data-ecom-spinner": "inline" },
    React.createElement("div", { className: "spinner" })));
